module.exports = __webpack_public_path__ + "static/media/66.248ff5aa.png";